<template>
<div class="chapter">
<div class="inner_page">
<p class="P_Frontbmatterbheads">Stencilling</p>
<p class="P_Chapterbintrobtext">Stencilling is an extremely effective way to add impressive decorations to your cakes and cookies quickly. For the best and most satisfying results, I recommend you use laser-cut culinary stencils made from durable food-grade plastic. How you choose to add a stencilled pattern will depend on the effect you wish to achieve and the size of the item to be stencilled. This taster from <em>The Contemporary Cake Decorating Bible</em> shows you various techniques using both edible dusts and royal icing; it also shows you how to make your own stencils and some possible other uses.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm.vue?201667ea